import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { buildRecordId } from '../recordIds';
import { DBLegacyExamTypeSchema, LegacyExamTypeSchema } from './schemas';

export const LegacyExamTypeCodecConfig: TransformerConfig<
  typeof LegacyExamTypeSchema,
  typeof DBLegacyExamTypeSchema,
  'id'
> = {
  name: 'LegacyExamType',
  clientSchema: LegacyExamTypeSchema,
  dbSchema: DBLegacyExamTypeSchema,
  transformers: [],
  derived: { id: examType => buildRecordId('examType', examType) },
};

export const encodeLegacyExamTypeToDb = createEncodeToDbFn(LegacyExamTypeCodecConfig);
export const decodeLegacyExamTypeFromDb = createDecodeFromDbFn(LegacyExamTypeCodecConfig);
